var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import symbolsJson from '../d/toc.json';
var SymbolController = /** @class */ (function () {
    function SymbolController(data) {
        var _this = this;
        Object.defineProperty(this, "symbolFonts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.entries(data).forEach(function (_a) {
            var e_1, _b;
            var _c = __read(_a, 2), fontName = _c[0], font = _c[1];
            var glyphs = {};
            _this.symbolFonts.set(fontName, {
                count: font.count,
                font: font.font,
                glyphs: glyphs,
            });
            try {
                for (var _d = __values(font.glyphs), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var glyph = _e.value;
                    glyphs[glyph.unicode] = glyph.url;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
    Object.defineProperty(SymbolController.prototype, "getSymbolUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var symbolFont = _a.symbolFont, unicode = _a.unicode;
            var symbol = this.symbolFonts.get(symbolFont);
            if (symbol) {
                return symbol.glyphs[unicode];
            }
            return '';
        }
    });
    Object.defineProperty(SymbolController.prototype, "getAvailableSymbolFonts", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __spreadArray([], __read(this.symbolFonts.keys()), false).sort();
        }
    });
    Object.defineProperty(SymbolController.prototype, "getAvailableSymbols", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fontName) {
            var dto = this.symbolFonts.get(fontName);
            if (!dto) {
                return null;
            }
            var keys = Object.keys(dto.glyphs);
            return { font: dto.font, count: dto.count, glyphs: keys };
        }
    });
    return SymbolController;
}());
export default new SymbolController(symbolsJson);
